import { useCallback } from "react"

import { env } from "@/env"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"
// adjust path to your shadcn/ui components
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group"

import { useMapLibre } from "./maplibre-context"

const STYLES = [
  { id: "streets", name: "Streets", url: "streets" },
  { id: "satellite", name: "Satellite", url: "satellite" },
  { id: "topo", name: "Terrain", url: "topo" },
  { id: "hybrid", name: "Hybrid", url: "hybrid" },
  { id: "outdoor", name: "Outdoor", url: "outdoor" },
  { id: "streets-dark", name: "Streets Dark", url: "streets-dark" },
]

interface MapStyleSwitcherProps {
  variant?: "dropdown" | "toggle" // choose which UI to render
}

export function MapStyleSwitcher({
  variant = "dropdown",
}: MapStyleSwitcherProps) {
  const map = useMapLibre() // map instance from your context

  const handleStyleChange = useCallback(
    (styleId: string) => {
      if (!map) return
      const style = STYLES.find((s) => s.id === styleId)
      if (!style) return
      const styleUrl = `https://api.maptiler.com/maps/${style.url}/style.json?key=${env.VITE_MAPTILER_KEY}`
      map.setStyle(styleUrl)
    },
    [map],
  )

  if (!map) return null // map not ready

  if (variant === "toggle") {
    return (
      <div className="absolute left-4 top-4 z-10 rounded-md border bg-background p-1 shadow-md">
        <ToggleGroup
          type="single"
          onValueChange={handleStyleChange}
          defaultValue="streets"
        >
          {STYLES.map((style) => (
            <ToggleGroupItem
              key={style.id}
              value={style.id}
              aria-label={style.name}
            >
              {style.name}
            </ToggleGroupItem>
          ))}
        </ToggleGroup>
      </div>
    )
  }

  return (
    <div className="absolute left-4 top-4 z-10 w-40">
      <Select onValueChange={handleStyleChange} defaultValue="streets">
        <SelectTrigger className="border bg-background shadow-md">
          <SelectValue placeholder="Map style" />
        </SelectTrigger>
        <SelectContent>
          {STYLES.map((style) => (
            <SelectItem key={style.id} value={style.id}>
              {style.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
